export default "__VITE_ASSET__BkKs6K0m__"